import React from "react";
import { useNavigate, Link } from "react-router-dom";
import "./css/ServiceRequestitem2.css";

const ServiceRequestItem2 = ({ request, loading }) => {
  const navigate = useNavigate();

  const handleRowClick = () => {
    navigate(`/ServiceNotesStatus/${request["Record Id"]}`);
  };

  if (loading) {
    return (
      <tr>
        <td colSpan="5" style={{ textAlign: "center", padding: "20px" }}>
          <div className="loading-bar">Loading...</div>
        </td>
      </tr>
    );
  }

  return (
    <tr
      onClick={handleRowClick}
      style={{ cursor: "pointer", borderBottom: "1px solid #eee" }}
      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f9fbfd"}
      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
    >
      <td style={{ width: "15%", padding: "12px 15px", fontSize: "14px", fontWeight: 600, color: "#333", fontFamily: "Open Sans, sans-serif" }}>
        <Link
          to={`/ServiceNotesStatus/${request["Record Id"]}`}
          onClick={(e) => e.stopPropagation()}
          style={{ textDecoration: "none", color: "#333", fontWeight: 600 }}
        >
          {request["Serial No"]}
        </Link>
      </td>
      <td style={{ width: "25%", padding: "12px 7px", fontSize: "14px", color: "#666", fontFamily: "Open Sans, sans-serif" }}>
        {request.Description}
      </td>
      <td style={{ width: "20%", padding: "12px 7px", fontSize: "14px", color: "#666", fontFamily: "Open Sans, sans-serif" }}>
        {request["Machine Name"]}
      </td>
      <td style={{ width: "15%", padding: "12px 7px", fontSize: "14px", color: "#666", fontFamily: "Open Sans, sans-serif" }}>
        {request.Type}
      </td>
      <td style={{ width: "10%", padding: "12px 7px", fontSize: "14px", fontFamily: "Open Sans, sans-serif" }}>
        <span style={{
          backgroundColor: "#D9EEF5",
          color: "#017CC2",
          padding: "4px 10px",
          fontSize: "13px",
          borderRadius: "10px",
          display: "inline-block",
          whiteSpace: "nowrap",
        }}>
          {request.Status}
        </span>
      </td>
    </tr>
  );
};

export default ServiceRequestItem2;
